import React from 'react';
import { Users, UserCheck, Clock, BarChart3 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SquareButton, ButtonGridLayout } from '../components/ui';

/**
 * Página de gestión de equipo
 */
export const Equipo: React.FC = () => {
  const navigate = useNavigate();

  /**
   * Maneja el click en el botón de Tu Plantilla
   */
  const handleTuPlantilla = () => {
    setTimeout(() => {
      navigate('/tu-plantilla');
    }, 200);
  };

  /**
   * Maneja el click en el botón de Asistencia
   */
  const handleAsistencia = () => {
    setTimeout(() => {
      navigate('/asistencia');
    }, 200);
  };

  /**
   * Maneja el click en el botón de Minutaje
   */
  const handleMinutaje = () => {
    setTimeout(() => {
      navigate('/jornadas');
    }, 200);
  };

  /**
   * Maneja el click en el botón de Estadísticas
   */
  const handleEstadisticas = () => {
    setTimeout(() => {
      navigate('/estadisticas');
    }, 200);
  };

  return (
    <div className="flex-1 p-4">
      <div className="space-y-6">
        <div className="bg-secondary-800 rounded-xl p-6 border border-secondary-700">
          <p className="text-secondary-400">
            Gestiona tu plantilla, controla la asistencia de los jugadores, registra los minutos de juego y revisa las estadísticas del equipo.
          </p>
        </div>
        
        {/* Botones de navegación */}
        <ButtonGridLayout>
          <SquareButton
            icon={Users}
            text="Tu Plantilla"
            onClick={handleTuPlantilla}
          />
          <SquareButton
            icon={UserCheck}
            text="Asistencia"
            onClick={handleAsistencia}
          />
          <SquareButton
            icon={Clock}
            text="Minutaje"
            onClick={handleMinutaje}
          />
          <SquareButton
            icon={BarChart3}
            text="Estadísticas"
            onClick={handleEstadisticas}
          />
        </ButtonGridLayout>
      </div>
    </div>
  );
};

export default Equipo;